import Vue from 'vue'

export const priceOffConfig: {endTime: string;offRate:number;show:boolean} = Vue.observable({
  endTime: '2022/05/27 18:00',
  offRate: 0.4,
  show: false
})
